import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
// Use the lazy auth attacher so the supabase-js client is NOT pulled into the
// main entry bundle (keeps ~53 KiB of unused JS off the homepage critical path).
import { attachSupabaseAuthLazy } from "./integrations/supabase/auth-attacher.local";

const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  // Never wrap/redirect Lovable system routes (auth email webhook, queue
  // processor, previews) — they authenticate themselves and must pass through.
  if (request && new URL(request.url).pathname.startsWith("/lovable/")) {
    return next();
  }
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    const msg = error instanceof Error ? error.message : String(error);
    if (
      request &&
      new URL(request.url).pathname.startsWith("/_serverFn/") &&
      /Server function info not found|Invalid server function ID/i.test(msg)
    ) {
      // Παλιά έκδοση σελίδας μετά από δημοσίευση — ο client θα κάνει reload.
      return new Response(JSON.stringify({ stale: true }), {
        status: 409,
        headers: {
          "content-type": "application/json",
          "x-mrpanda-stale": "1",
          "cache-control": "no-store",
        },
      });
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  requestMiddleware: [errorMiddleware],
  functionMiddleware: [attachSupabaseAuthLazy],
}));
